import { render, staticRenderFns } from "./TableSessions.vue?vue&type=template&id=b8b90c02&scoped=true"
import script from "./TableSessions.js?vue&type=script&lang=js&external"
export * from "./TableSessions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b90c02",
  null
  
)

export default component.exports